import Login from 'components/Controller/Login'
import { Navigate } from 'react-router-dom'
import Auth from './Auth'
const AuthModule = [
	{
		path: '/',
		element: <Navigate to='auth?tab=0' />,
	},
	{
		path: 'auth',
		element: (
			<Login>
				<Auth />
			</Login>
		),
	},
]
export default AuthModule
